import { apiClient } from '@/lib/apiClient';
import { CallLog, CreateCallLogRequest, UpdateCallLogRequest, CallLogApiResponse, CallLogsListResponse } from '@/types/callLog';

export const callLogsApi = {
  // Save a new call log
  saveCallLog: async (callLog: CreateCallLogRequest): Promise<CallLogApiResponse> => {
    try {
      const data = await apiClient.post<CallLog>('/log/', callLog);
      return { success: true, data };
    } catch (error) {
      console.error('Error saving call log:', error);
      return { success: false, error: 'Failed to save call log' };
    }
  },

  // Update an existing call log
  updateCallLog: async (logId: number, updates: UpdateCallLogRequest): Promise<CallLogApiResponse> => {
    try {
      const data = await apiClient.put<CallLog>(`/log/${logId}`, updates);
      return { success: true, data };
    } catch (error) {
      console.error(`Error updating call log ${logId}:`, error);
      return { success: false, error: 'Failed to update call log' };
    }
  },

  // Get all call logs for a specific user
  getCallLogsByUserId: async (userId: number): Promise<CallLogsListResponse> => {
    try {
      const data = await apiClient.get<CallLog[]>(`/log/user/${userId}`);
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching call logs for user:', error);
      return { success: false, error: 'Failed to fetch call logs' };
    }
  },

  // Get all call logs
  getAllCallLogs: async (): Promise<CallLogsListResponse> => {
    try {
      const data = await apiClient.get<CallLog[]>('/log/');
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching all call logs:', error);
      return { success: false, error: 'Failed to fetch call logs' };
    }
  },

  // Get a single call log by ID
  getCallLogById: async (logId: number): Promise<CallLogApiResponse> => {
    try {
      const data = await apiClient.get<CallLog>(`/log/${logId}`);
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching call log:', error);
      return { success: false, error: 'Failed to fetch call log' };
    }
  }
};
